import { render, staticRenderFns } from "./YpoError.vue?vue&type=template&id=164deae8&scoped=true&"
import script from "./YpoError.vue?vue&type=script&lang=js&"
export * from "./YpoError.vue?vue&type=script&lang=js&"
import style0 from "./YpoError.vue?vue&type=style&index=0&id=164deae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164deae8",
  null
  
)

export default component.exports